var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0942633 11.8574V19.6162L14.0256 32.7415L19.8491 38.228L33.0909 50.7037H41.3263L26.9532 37.1627C34.864 34.5503 40.5771 27.4301 40.5771 19.1142C40.5771 8.60132 31.4475 0 20.289 0H6.7603H0.000452069V1.39055L5.82391 6.87708L20.9713 21.1476H29.2066L12.5829 5.48567H20.2881C28.2321 5.48567 34.7532 11.629 34.7532 19.1138C34.7532 21.2233 34.2347 23.2271 33.3127 25.0165C32.4454 26.6984 31.2217 28.1909 29.7354 29.4047C27.6373 31.1187 25.0171 32.2771 22.1407 32.629L0.0942633 11.8574ZM7.59524 45.2167L0 51.0039V30.3025L8.41223 38.2276L15.8306 45.2167L21.6541 50.7032H13.4192L7.59524 45.2167Z",
    fill: "#E83B37"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.bb227055.svg";
export { ForwardRef as ReactComponent };